/**
 * Name the environment a Freshdesk ticket is opened from, read from the host name.
 *
 * Support triages on this value first, so an unrecognised host is reported as PROD rather
 * than as "unknown" : the costly mistake is handling a production incident as if it were a
 * test one, never the reverse. Only the hosts we positively recognise as non-production
 * are downgraded.
 */
function environmentFromHost(hostname){
    var host = (hostname || "").trim().toLowerCase() ;
    if(!host){ return "PROD" ; }
    if(host === "localhost" || host === "127.0.0.1" || /(^|\.)localhost$/.test(host)){
        return "LOCAL" ;
    }
    //match demo/test as a whole host segment : `testa-corp.fr` is a customer, not a test rig,
    //and downgrading a production incident is the costly mistake
    if(/(^|[.-])demo\d*([.-]|$)/.test(host)){ return "DEMO" ; }
    if(/(^|[.-])test\d*([.-]|$)/.test(host)){ return "TEST" ; }
    return "PROD" ;
}

/**
 * Keep only the screen the consultant was on.
 *
 * Opening the composer appends its own route to the hash (popup routes come after a `~`,
 * see AppController._getRoutes), so an URL read from inside the popup points at the popup.
 * Support follows this link to reproduce the problem : it has to land on the screen, not
 * on a dialog the reader never asked for.
 */
function screenUrlFromHref(href){
    const url = String(href || "") ;
    const hashAt = url.indexOf("#") ;
    if(hashAt === -1){ return url ; }
    const base = url.substring(0, hashAt) ;
    const hash = url.substring(hashAt) ;
    const popupAt = hash.indexOf("~") ;
    if(popupAt === -1){ return url ; }
    return (base + hash.substring(0, popupAt)).replace(/#$/, "") ;
}

module.exports = {
    environmentFromHost: environmentFromHost,
    screenUrlFromHref: screenUrlFromHref
} ;
